import { css } from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

export const _hyperlinkStyle = css`
  text-decoration: none;
  color: ${plume.COLORS.PRIMARY_BLUE};

  &:hover {
    text-decoration: none;
  }
`

export const _text2Style = css`
  ${plume.styles.copy.Base};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const _claimStyle = css`
  ${_text2Style}

  align-items: center;
  display: flex;
  font-weight: 600;
  margin-bottom: 30px;
  text-align: center;

  p {
    ${_text2Style}
  }

  &::before {
    margin-right: 17.5px;
    content: url("data:image/svg+xml; utf8, <svg width='21' height='16' fill='none' version='1.1' viewBox='0 0 21 16' xmlns='http://www.w3.org/2000/svg'><path d='m5.2568 15.58c-0.96454 0-1.8487-0.2759-2.6525-0.8276-0.80378-0.5843-1.4468-1.3632-1.9291-2.337-0.45012-0.9737-0.67518-2.0448-0.67518-3.2133 0-1.493 0.32151-2.8725 0.96454-4.1383 0.67518-1.2658 1.6076-2.3369 2.7972-3.2133 1.1896-0.87635 2.5721-1.493 4.1475-1.8501l1.1092 3.7975c-0.90024 0.2272-1.704 0.568-2.4114 1.0224-0.67518 0.42195-1.2218 0.94127-1.6397 1.558-0.38582 0.58424-0.57873 1.2172-0.57873 1.8988v0.24343c0.38582-0.25966 0.85201-0.38949 1.3986-0.38949 0.64303 0 1.2218 0.16229 1.7362 0.48687 0.54657 0.32457 0.98062 0.76275 1.3021 1.3145 0.32152 0.55178 0.48227 1.1685 0.48227 1.8501s-0.1929 1.3145-0.57872 1.8988c-0.35367 0.5842-0.83594 1.0548-1.4468 1.4119-0.61088 0.3246-1.2861 0.4868-2.0255 0.4868zm11.14 0c-0.9645 0-1.8487-0.2759-2.6525-0.8276-0.8038-0.5843-1.4468-1.3632-1.9291-2.337-0.4501-0.9737-0.6751-2.0448-0.6751-3.2133 0-1.493 0.3215-2.8725 0.9645-4.1383 0.6752-1.2658 1.6076-2.3369 2.7972-3.2133 1.1896-0.87635 2.5721-1.493 4.1475-1.8501l1.1092 3.7975c-0.9002 0.2272-1.704 0.568-2.4113 1.0224-0.6752 0.42195-1.2218 0.94127-1.6398 1.558-0.3858 0.58424-0.5787 1.2172-0.5787 1.8988v0.24343c0.3858-0.25966 0.852-0.38949 1.3986-0.38949 0.643 0 1.2218 0.16229 1.7362 0.48687 0.5465 0.32457 0.9806 0.76275 1.3021 1.3145s0.4823 1.1685 0.4823 1.8501-0.1929 1.3145-0.5787 1.8988c-0.3537 0.5842-0.836 1.0548-1.4469 1.4119-0.6108 0.3246-1.286 0.4868-2.0255 0.4868z' fill='%23F0A781'/></svg>");
  }

  &::after {
    margin-left: 20px;
    content: url("data:image/svg+xml; utf8, <svg width='21' height='16' fill='none' version='1.1' viewBox='0 0 21 16' xmlns='http://www.w3.org/2000/svg'><path d='m15.192 0.42036c0.9645 0 1.8487 0.27589 2.6525 0.82767 0.8037 0.58424 1.4468 1.3632 1.929 2.337 0.4502 0.97372 0.6752 2.0448 0.6752 3.2133 0 1.493-0.3215 2.8725-0.9645 4.1383-0.6752 1.2659-1.6076 2.337-2.7972 3.2133-1.1896 0.8764-2.5721 1.4931-4.1475 1.8501l-1.1092-3.7975c0.9002-0.2272 1.704-0.568 2.4113-1.0224 0.6752-0.422 1.2218-0.9413 1.6397-1.558 0.3858-0.58424 0.5788-1.2172 0.5788-1.8988v-0.24343c-0.3859 0.25966-0.8521 0.38949-1.3986 0.38949-0.6431 0-1.2218-0.16229-1.7362-0.48687-0.5466-0.32457-0.9806-0.76275-1.3021-1.3145s-0.4823-1.1685-0.4823-1.8501 0.1929-1.3145 0.5787-1.8988c0.3537-0.58424 0.836-1.0549 1.4468-1.4119 0.6109-0.32458 1.2861-0.48686 2.0256-0.48686zm-11.14 0c0.96454 0 1.8487 0.27589 2.6525 0.82767 0.80378 0.58424 1.4468 1.3632 1.9291 2.337 0.45012 0.97372 0.67518 2.0448 0.67518 3.2133 0 1.493-0.32152 2.8725-0.96454 4.1383-0.67518 1.2659-1.6076 2.337-2.7972 3.2133-1.1896 0.8764-2.5721 1.4931-4.1475 1.8501l-1.1092-3.7975c0.90023-0.2272 1.704-0.568 2.4114-1.0224 0.67518-0.422 1.2218-0.9413 1.6397-1.558 0.38582-0.58424 0.57872-1.2172 0.57872-1.8988v-0.24343c-0.38581 0.25966-0.85201 0.38949-1.3986 0.38949-0.64303 0-1.2218-0.16229-1.7362-0.48687-0.54658-0.32457-0.98062-0.76275-1.3021-1.3145-0.32151-0.55178-0.48227-1.1685-0.48227-1.8501s0.19291-1.3145 0.57873-1.8988c0.35367-0.58424 0.83593-1.0549 1.4468-1.4119 0.61088-0.32458 1.2861-0.48686 2.0255-0.48686z' fill='%23F0A781'/></svg>");
  }
`

export const _imageStyle = css`
  width: 100%;
  border-radius: 2px; /* border-radius: 12px; */
`

export const _textArticleStyle = css`
  ${plume.styles.copy.Base};
  font-size: 18px;
  line-height: 150%;
`

export const _paragraphStyle = css`
  ${_textArticleStyle}
  font-weight: 300;
  margin: 20px 0;
  min-height: 1.5em;
`

export const _listItemStyle = css`
  ${_paragraphStyle}

  margin: 10px 0;
  counter-increment: item;
  position: relative;

  &::before {
    position: absolute;
    display: inline-block;
    width: 1em;
    padding-right: 7px;
    font-weight: bold;
    text-align: right;
    left: 0;
    top: 0;
    transform: translateX(-100%);
  }
`

export const _orderedListStyle = css`
  list-style: none;
  padding: 0 0 0 46px;
  margin: 25px 0;
  counter-reset: item;

  & > li::before {
    content: counter(item) '.';
  }
`

export const _unorderedListStyle = css`
  list-style: none;
  padding: 0 0 0 46px;
  margin: 25px 0;

  & > li::before {
    content: '\\2022';
  }
`

export const _boldStyle = css`
  font-weight: 600;
`
